<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    mode="passive"
    :rules="rules"
  >
    <b-form-group :label="label" :description="description" :label-for="id">
      <!-- <input
        class="hidden"
        @change="onChange"
        type="file"
        :ref="defaultRef"
        :name="name"
        :accept="accept"
      /> -->
      <CropperModal
        v-if="withCropper"
        @confirm="onCropFinished"
        ref="imgCropper"
        v-model="cropperModal"
        :withCropper="withCropper"
        :aspectRatio="cropAspectRatio"
      />
      <div class="" style="position: relative">
        <input type="text" :value="getFileName" class="hidden" />
        <div v-if="imagePreview">
          <input
            @change="onChange"
            type="file"
            class="dropbox-input cursor-pointer"
            accept="image/*"
          />
          <img :src="imagePreview" class="img-fluid rounded-lg" id="preview" />
        </div>
        <div
          :class="{ 'image-border-danger': errors.length > 0 }"
          v-else
          class="rounded image-border cursor-pointer py-5 w-100 mb-50"
        >
          <input
            @change="onChange"
            type="file"
            class="dropbox-input cursor-pointer"
            accept="image/*"
          />
          <div class="w-100 text-center">
            <feather-icon icon="ImageIcon" class="" size="30" />
          </div>
        </div>
      </div>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>
<script>
import { ValidationProvider } from "vee-validate";

import {
  BFormGroup,
  BFormFile,
  BInputGroupAppend,
  BFormInput,
  BInputGroup,
} from "bootstrap-vue";
import { required } from "@validations";
import SizeValidationMixin from "@/utils/mixins/file-size-validation";
import CropperModal from "./CropperModal.vue";
export default {
  components: {
    ValidationProvider,
    BFormGroup,
    BFormFile,
    BInputGroupAppend,
    BFormInput,
    BInputGroup,
    CropperModal,
  },
  mixins: [SizeValidationMixin],
  props: {
    id: {
      type: String,
      default: () => "input",
    },
    name: {
      type: String,
    },

    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    description: {
      type: String,
      default: () => "",
    },
    accept: {
      type: String,
      default: () => "image/*",
    },
    withCropper: Boolean,
    cropAspectRatio: Number,
    value: {},
  },
  data() {
    return {
      required,
      uploadedFile: null,
      fileName: null,
      cropperModal: false,
    };
  },
  computed: {
    defaultName() {
      return this.name || this.label;
    },

    imagePreview() {
      return this.value && typeof this.value !== "string"
        ? URL.createObjectURL(this.value)
        : this.value && typeof this.value === "string"
        ? this.value
        : null;
    },
    getFileName() {
      return this.fileName
        ? this.fileName
        : this.value && typeof this.value === "string"
        ? this.value
        : null;
    },
  },
  methods: {
    onCropFinished(file) {
      this.$emit("input", file);
    },
    onChange(e) {
      var file = e.target.files[0];
      this.validateFileSize(file)
        .then(() => {
          if (this.withCropper) {
            this.$refs.imgCropper.loadImage(e);
          } else {
            this.fileName = file.name;
            this.$emit("input", file);
            this.$emit("change", e);
          }
        })
        .catch(() => {
          this.$emit("input", null);
        });
    },
  },
};
</script>

<style lang="scss">
.image-border {
  &:hover {
    box-shadow: 0 5px 10px 0 rgba(34, 41, 47, 0.2);
    opacity: 0.6;
  }
  transition: all 0.2s ease;
  border: 2px dashed var(--secondary);
}
.image-border-danger {
  border-color: var(--danger) !important;
}
.dropbox-input {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  top: 0;
}
</style>
